import ExpedientForm from "./form";
import { useAttendanceLocalExpedientCreate } from "../../../../../../../services/api-tansquery/attendance-local/expedient/create";

type ExpedientFormProps = {
    slug: string;
    buttonTrigger?: React.ReactNode;
};

export default function ExpedientFormCreate(props: ExpedientFormProps) {
    const mutation = useAttendanceLocalExpedientCreate();

    return (
        <ExpedientForm
            {...props}
            mutation={mutation}
        />
    );
}
